const { usableValue } = require('../usable-value')

// ? ******************************************************************************************
// ? ******************************************************************************************

/**
 * @param {string} dataType
 * @param {*} value
 * @returns {number|string|{month: (number|undefined), year: (number|undefined)}|*}
 */
function parseDataType (dataType, value) {
  if (!dataType) return value
  if (!usableValue(value)) return

  let val = value

  if (dataType === 'number') {
    val = val
      .toString()
      .replace(/[^0-9.,]/g, '')
      .replace(',', '.')

    val = val.includes('.')
      ? parseFloat(val)
      : parseInt(val, 10)
  } else if (dataType === 'date') {
    let year = val.year
    let month = val.month

    if (val.toString().includes('-')) {
      const [_year, _month] = val.split('-')

      year = _year
      month = _month
    }

    val = {
      year: parseInt(year) || undefined,
      month: parseInt(month) || undefined
    }
  } else if (dataType === 'boolean') {
    val = !!(val === true || val === 'true')
  } else if (dataType === 'string') {
    val = val.toString()
  }

  return val
}

module.exports = { parseDataType }
